export * from './agenda.service';
export * from './authorization.service'
export * from './apartment.service'
export * from './user.service'
export * from './ticket.service';
export * from './home.service';
export * from './contact.service';
export * from './block.service';
export * from './search.service';
export * from './tenant.service';
export * from './notification.service';
export * from './settings.service';
export * from './profile.service';
export * from './profile.notification.service';
export * from './owner.service';
export * from './document.service';
export * from './reception.service';
export * from './bm.service';
export * from './maintenance.service';
export * from './am.service';



// WEBPACK FOOTER //
// ./src/services/index.ts